import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Alert } from 'react-magma-dom';
import * as React from 'react';
export default {
  Link,
  LeadParagraph,
  Alert,
  React
};